const LOCKER_CONFIG = {
  casesCount: 6,
  caseMoveDistance: 0.9,
  caseMoveSpeed: 4,
  allCasesAnimationDelayCoefficient: 450,
}


export { LOCKER_CONFIG };
